import { render, staticRenderFns } from "./GouwuShangquanFenxiDetail.vue?vue&type=template&id=35b53cf5&scoped=true&"
import script from "./GouwuShangquanFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./GouwuShangquanFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./GouwuShangquanFenxiDetail.vue?vue&type=style&index=0&id=35b53cf5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b53cf5",
  null
  
)

export default component.exports